<template>
  <div id="vehicle-filter-banners-background-component" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div id="video-banner-row" :style="{backgroundImage: bgPhoto}">
    </div>
    <div id="video-banner-overlay">
      <div class="overlay-content">
        <video v-if="images.videoLink.length > 0" autoplay="true" class="hidden-xs" id="homepage-background-video" loop="true" muted="true">
          <source class="ajax-video"
            :src="images.videoLink"
            type="video/mp4">
        </video>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <h1 id="call-to-action-overlay">Welcome to Auto Dealer</h1>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 col-md-push-4">
              <div class="overlay-home-banners">
                <div class="container-fluid no-padding">
                  <div class="full-banner-image">
                    <div class="home-banners-box carousel slide" data-ride="carousel" id="hpBannerCarouselMini" role="region">
                      <div class="carousel-inner" v-if="images.homeBanners.length > 0">
                        <div class="item" v-for="(banner, index) in images.homeBanners" :key="index" :class="[index === 0 ? activeClass: '']">
                          <img :src="banner">
                        </div>
                      </div>
                      <div class="carousel-inner" v-else>
                        <div class="item" v-for="(preview, index) in bannerComponent.previews" :key="preview.index" :class="[index === 0 ? activeClass: '']">
                          <img :src="preview.image">
                        </div>
                      </div>
                      <a class="left carousel-control" href="#hpBannerCarouselMini" role="button" data-slide="prev">
                        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                      </a>
                      <a class="right carousel-control" href="#hpBannerCarouselMini" role="button" data-slide="next">
                        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                      </a>
                    </div>
                  </div>
                  <div class="full-banner-image"></div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-md-pull-8">
              <div class="overlay-search-section">
                <div class="overlay-search-form">
                  <div class="vehicle-browse-ajax">
                    <form action="/vehicles" class="vehicle-search-form" method="get">
                      <input class="inventory-type set-on-load" name="new" type="hidden" value="true">
                      <div class="overlay-inventory-buttons">
                        <div class="row">
                          <div class="col-xs-6">
                            <button class="btn btn-lg inventory-type-button-block search-inv-type new-side-search track-click active" data="true" data-action="Browse New Vehicles" data-category="Home Page Actions"
                              type="button">New</button>
                          </div>
                          <div class="col-xs-6">
                            <button class="btn btn-lg inventory-type-button-block search-inv-type used-side-search track-click" data="false" data-action="Browse Pre-Owned Vehicles" data-category="Home Page Actions" type="button">Used</button>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <select class="form-control vehicle-search vehicle-search-make" name="make">
                          <option value="default">{{brandName}}</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <select class="form-control vehicle-search vehicle-search-model" name="model">
                          <option value="default">Model</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <select class="form-control vehicle-search vehicle-search-trim" name="trim">
                          <option value="default">Trim</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <input class="btn btn-block search-form-btn vehicle-search-submit" value="Go"></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      activeClass: 'active',
      bodyComponents: this.$store.state.bodyComponents
    };
  },
  computed: {
    bannerComponent() {
      return this.bodyComponents.find(c => c.title === "Default Homepage Banner");
    },
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    bgPhoto () {
      if (this.brand !== 'honda') {
        return 'url(' + this.images.lifestyleImages.defaultImage + ')';
      } else {
        return 'url(' + this.images.lifestyleImages.suvImage + ')';
      }
    }
  },
  mounted() {
    (function() {
      
      var c = {
        init: function() {
          $('#hpBannerCarouselMini').carousel({
            interval: 4000
            })
        }
      }
      $(document).ready(c.init);
    })(jQuery);
  }
};
</script>
  
<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
#vehicle-filter-banners-background-component {
  min-height: 600px;
  height: 35vw;
  max-height: 70vh;
  position: relative;
  overflow: hidden;
  font-family: 'Helvetica Neue', Arial, sans-serif;
}
#vehicle-filter-banners-background-component #video-banner-row {
    position: absolute;
    z-index: -1;
    top: -10%;
    left: 0px;
    bottom: 0px;
    right: 0px;
    overflow: hidden;
    background-size: cover;
    background-color: #222;
    background-repeat: no-repeat;
    background-position: 50% 50%;
}
#vehicle-filter-banners-background-component #video-banner-overlay {
    display: table;
    width: 100%;
    text-align: center;
    height: 100%;
}
#vehicle-filter-banners-background-component #video-banner-overlay .overlay-content {
    display: table-cell;
    max-width: 1200px;
    vertical-align: middle;
    padding: 0 10px;
    overflow: hidden;
}
#vehicle-filter-banners-background-component #video-banner-overlay .overlay-content video#homepage-background-video {
  position: absolute;
  top: -30%;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
  background-size: cover;
}
#vehicle-filter-banners-background-component #call-to-action-overlay {
    text-transform: uppercase;
    color: #fff;
    font-weight: 300;
    margin-top: 5px;
    margin-bottom: 25px;
    font-size: 4em;
}
#vehicle-filter-banners-background-component #video-banner-overlay .overlay-content .overlay-home-banners {
    max-width: 800px;
    margin: auto;
    padding: 0 15px;
}
#vehicle-filter-banners-background-component .no-padding {
    padding: 0 !important;
}
#vehicle-filter-banners-background-component #video-banner-overlay .overlay-content .overlay-search-section {
    max-width: 800px;
    margin: 0 auto;
    padding: 0 15px;
}
#vehicle-filter-banners-background-component #video-banner-overlay .overlay-content .overlay-search-section .overlay-inventory-buttons .btn {
    display: inline-block;
    margin-bottom: 10px;
    display: block;
    width: 100%;
}
#vehicle-filter-banners-background-component #video-banner-overlay .overlay-content .overlay-search-section .overlay-search-form .btn {
    background: var(--primary-color);
    font-size: 18px;
    color: white;
    font-weight: 600;
}
#vehicle-filter-banners-background-component[data-brand="cjdr"] #video-banner-overlay .overlay-content .overlay-search-section .overlay-search-form .btn {
    background: var(--secondary-color);
}
#vehicle-filter-banners-background-component #video-banner-overlay .overlay-content .overlay-search-section .form-group {
    margin-bottom: 10px;
}
#vehicle-filter-banners-background-component #video-banner-overlay .overlay-content .overlay-search-section .overlay-search-form .vehicle-search {
    border-radius: 0;
    -webkit-appearance: none;
    -webkit-border-radius: 0px;
    max-height: 40px;
    background: #fff url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png) no-repeat 98% center;
}
#vehicle-filter-banners-background-component select.vehicle-search, #vehicle-filter-banners-background-component select.top-search {
    line-height: 1em;
    font-size: 1.3em;
}
#hpBannerCarouselMini .carousel-control {
    width: 5%;
}

@media (max-width: 1399px) {
  #vehicle-filter-banners-background-component #video-banner-overlay .overlay-content video#homepage-background-video {
    top: 0;
  }
  #vehicle-filter-banners-background-component #video-banner-row {
    top: 0;
  }
}

@media(max-width: 991px) {
  #vehicle-filter-banners-background-component {
    min-height: 700px;
  }
  #vehicle-filter-banners-background-component #call-to-action-overlay {
    font-size: 3.5em;
  }
  #vehicle-filter-banners-background-component #video-banner-overlay .overlay-content .overlay-home-banners {
    margin: 15px auto;
  }
}
</style>